import React, {useRef, useState, useEffect, RefObject} from "react"
import {Enhancer} from "widgets-shared/core"
import {BreakpointValues} from "widgets-shared/types/theme"

import { debounce } from "widgets-shared/utilities"
import {getBreakpointSize} from "widgets-shared/utilities"
import useEventListener from "smartstream-widgets/hooks/useEventListener/useEventListener"

type Props = {
    config?: {breakpoints?: BreakpointValues};
    theme?: {breakpoints: {values: BreakpointValues}};
};

export const withWidthBreakpoints: Enhancer = (ComposedComponent: any) => (
    props: Props,
): React.ReactNode => {
    const defaultBreakpoints: BreakpointValues = {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    };
    const configBreakpoints: BreakpointValues | null | undefined =
      (props.config && props.config.breakpoints) ||
      (props.theme && props.theme.breakpoints.values);
    const breakpointValues: BreakpointValues = {
      ...defaultBreakpoints,
      ...configBreakpoints,
    };
    const sizeContainerRef: HTMLElement | null | undefined | RefObject<HTMLDivElement> = useRef(
      null,
    );
    const [breakpointSize, setBreakpointSize] = useState();
    const debouncedHandleResize = debounce(() => {
      const sizeContainer = sizeContainerRef.current;
      if (!sizeContainer) return;
      const containerWidth = +sizeContainer.offsetWidth;
      setBreakpointSize(getBreakpointSize(containerWidth, breakpointValues));
    }, 300);

    useEventListener("resize", debouncedHandleResize);

    useEffect(() => {
      const sizeContainer = sizeContainerRef.current;
      if (!sizeContainer) return;
      const containerWidth = +sizeContainer.offsetWidth;
      if (!containerWidth || !breakpointSize)
        setBreakpointSize(
          getBreakpointSize(containerWidth, breakpointValues),
        );
    }, []);
    return (
      <div
        className={"sizedContainer"}
        ref={sizeContainerRef}
        style={{height: "100%"}}
      >
        <ComposedComponent breakpointSize={breakpointSize} {...props} />
      </div>
    );
};
